module.exports = __webpack_public_path__ + "img/start1.08c4570a.svg";